import Cookies from 'js-cookie';
import { useGetCurrentUserQuery, useUserNavigationQuery } from '../store/user/userApi';


export const GuestGuard = (): boolean => {
    const token = Cookies.get('accessToken');
    if (token) {
        return false
    }
    else {
        return true
    }
};

export const AdminGuard = (): boolean => {
    // const { data }: any = !role && useGetCurrentUserQuery();
    const token = Cookies.get('accessToken');
    return token ? (Cookies.get('roles') === 'admins' || Cookies.get('roles') === 'partners' || Cookies.get('roles') === 'super_admin') : false
};


export const PartnerAgentGuard = (): boolean => {
    const role = Cookies.get('roles')
    const { data }: any = !role && useGetCurrentUserQuery();
    const token = Cookies.get('accessToken');
    return token ? role ? (role === 'partners' || role === 'partner' || role === 'agents' || role === 'agent') : (data && data?.groups && data?.groups?.length) ? Boolean(data?.groups?.includes('partners') || data?.groups?.includes('agents') || data?.groups?.includes('partner') || data?.groups?.includes('agent')) : false : false;
};

export const PartnerGuard = (): boolean => {
    const role = Cookies.get('roles')
    const token = Cookies.get('accessToken');
    return token ? (role === 'partners' || role === 'partner') : false;
};

export const PartnerRoutesGuard = (path: any): boolean => {
    const token = Cookies.get('accessToken');
    const dataRead = useUserNavigationQuery();
    const formatData = dataRead?.data
    const findParent = (formatData && formatData?.data && formatData?.data?.length > 0) ? formatData?.data?.find((item: any) => item?.path === path) : false
    if ((token ? Cookies.get('roles') === 'admins' : false) || !token) {
        return true
    }
    return !dataRead?.data?.data || !!findParent
};

export const PartnerChildRoutesGuard = (parentPath: any, childPath: any) => {
    const token = Cookies.get('accessToken');
    if ((token ? Cookies.get('roles') === 'admins' : false) || !token) {
        return true
    }
    const dataRead: any = useUserNavigationQuery();
    const formatData = dataRead?.data
    const findParent = (formatData?.data && formatData?.data?.length > 0) && formatData?.data?.find((item: any) => item?.path === parentPath)
    const findChild = findParent && findParent?.children && findParent?.children?.length > 0 && findParent?.children?.find((item: any) => item?.path === childPath)
    return !dataRead?.data?.data || !!findChild
}
